<template>
    <!-- 继续率配置 -->
    <div class="main-container appointment" style="padding-top:5px">
        <div class="header">
            <span>{{ queryParams.type == 1 ? '承保保单列表' : '实收保单列表' }}</span>
            <Button @click="goBack" type="primary" ghost>返回</Button>
        </div>
        <div class="total-wrap">
            <span
                >继续率月份：{{ queryParams.year }}-{{ Number(queryParams.month) < 10 ? '0' + queryParams.month : queryParams.month }}</span
            >
            <span v-if="queryParams.salesManName"> 业务员：{{ queryParams.salesManCode }}/{{ queryParams.salesManName }} </span>
            <span>
                <span v-if="queryParams.owerType == 1" class="label">保险公司</span>
                <span v-else-if="queryParams.owerType == 2" class="label">通道公司</span>
                <span v-else-if="queryParams.owerType == 3" class="label">
                    <template v-if="queryParams.groupByType == 1">团队</template>
                    <template v-else-if="queryParams.groupByType == 2">所属机构</template>
                    <template v-else>机构名称</template>
                </span>
                <span v-else-if="queryParams.owerType == 4" class="label">渠道</span>
                <span>
                    <span>：{{ queryParams.owerName }}</span>
                    <span v-if="queryParams.groupName"> / {{ queryParams.groupName }}</span>
                </span></span
            >
            <span v-if="queryParams.companyName"> 保险公司：{{ queryParams.companyName }} </span>
            <span v-if="queryParams.channelName"> 通道公司：{{ queryParams.channelName }} </span>
            <span v-if="queryParams.productName"> 产品：{{ queryParams.productName }} </span>
            <span v-if="queryParams.topOrgName"> 签约机构：{{ queryParams.topOrgName }} </span>
            <span>
                <span>{{ queryParams.rateMode == 1 ? '年度' : '月度' }}</span>
                <span>
                    <template v-if="queryParams.calculateIndex == 1">R13</template>
                    <template v-else-if="queryParams.calculateIndex == 2">{{ queryParams.type == 3 ? 'R13' : 'R25' }}</template>
                    <template v-else-if="queryParams.calculateIndex == 3">{{ queryParams.type == 3 ? 'R25' : 'R37' }}</template>
                    <template v-else>{{ queryParams.type == 3 ? 'R37' : 'R49' }}</template>
                </span>
                <span>{{ queryParams.type == 2 || queryParams.type == 3 ? '实收' : '承保' }}</span>
                <span>数据范围：</span>
                <span
                    >{{ queryParams.receiptTimeBegin || queryParams.insureTimeBegin || queryParams.lastReceiptTimeBegin }} 至
                    {{ queryParams.receiptTimeEnd || queryParams.insureTimeEnd || queryParams.lastReceiptTimeEnd }}</span
                >
            </span>
        </div>
        <div class="search-box min">
            <div class="input-item">
                <span class="label">保单号</span>
                <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
            </div>
            <div class="btn-item">
                <Button type="primary" @click="searchAjax()">搜索</Button>
                <Button type="primary" ghost @click="exportExcel()">导出</Button>
            </div>
        </div>
        <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData">
            </Table>
        </div>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from './policyList.config.js';
export default {
    mixins: [pageTool, config, common],
    props: {},
    data() {
        return {
            tableData: [],
            loading: false,
            type: '',
            queryParams: {},
            selList: []
        };
    },
    watch: {},
    computed: {},
    created() {
        this.queryParams = this.$route.query;
        this.type = this.$route.query.type; //承收1 实收2 上一年度3
        this.searchParams.calculateType = this.$route.query.type;
        this.searchParams.rateId = this.$route.query.id;
        this.searchParams.receiptTimeBegin = this.$route.query.receiptTimeBegin;
        this.searchParams.receiptTimeEnd = this.$route.query.receiptTimeEnd;
        this.searchParams.insureTimeBegin = this.$route.query.insureTimeBegin;
        this.searchParams.insureTimeEnd = this.$route.query.insureTimeEnd;
        this.searchParams.lastReceiptTimeBegin = this.$route.query.lastReceiptTimeBegin;
        this.searchParams.lastReceiptTimeEnd = this.$route.query.lastReceiptTimeEnd;
        this.searchParams.groupId = this.$route.query.groupId;
        this.searchParams.salesManId = this.$route.query.salesManId;
        this.searchParams.hasSubOrg = this.$route.query.hasSubOrg;
        this.searchParams.productCode = this.$route.query.productCode;
        this.searchParams.supplierId = this.$route.query.supplierId;
        this.searchParams.supplierType = this.$route.query.supplierType;
        this.searchParams.owerId = this.$route.query.owerId;
    },
    mounted() {
        this.init();
    },
    methods: {
        goBack() {
            let routerType = this.$route.query.routerType; //继续率统计类型 1、保司 2、机构 3、团队 4、个人 5、渠道'
            let path = '';
            if (routerType == 1) {
                path = '/renewalManage/continuityRate/top';
            } else if (routerType == 2) {
                path = '/renewalManage/continuityRate/org';
            } else if (routerType == 3) {
                path = '/renewalManage/continuityRate/group';
            } else if (routerType == 4) {
                path = '/renewalManage/continuityRate/person';
            } else if (routerType == 5) {
                path = '/renewalManage/continuityRate/channel';
            }
            path && this.back({ path, query: { type: routerType } });
        },
        // 导出
        exportExcel() {
            this.isLoading = true;
            this.$http({
                url: '/buz/continuityRatePolicy/export',
                type: 'POST',
                responseType: 'blob',
                data: { ...this.searchParams, owerType: this.queryParams.owerType }
            })
                .then(res => {
                    this.isLoading = false;
                    this.$units.daochu(res);
                })
                .catch(e => {
                    this.isLoading = false;
                });
        },
        init() {
            this.tableData = [];
            this.getColumns();
            this.initListAjax('/buz/continuityRatePolicy/read/list');
        },
    }
};
</script>
<style lang="scss" scoped>
@import './policyList.scss';
.total {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    align-items: center;
    b {
        font-weight: 400;
        color: #236dff;
    }
    .ivu-btn {
        height: 26px;
        font-size: 12px;
        width: 80px;
        border-radius: 2px;
    }
}
</style>
